import { ActionQueue, ErrorCause } from './action-queue.model';
import { Account } from '@libs/src/models/account.model';
import { PreregistrationAccount } from '@main-client/src/app/invite-csv/invite-csv-view/invite-csv-view.interface';

export const ACTION_ITEM_DELETE_ACCOUNT = 'delete-account';
export const ACTION_ITEM_INVITE = 'invite';
export const ACTION_ITEM_REMOVE_ACCOUNT_FROM_GROUP =
  'remove-account-from-group';
export const ACTION_ITEM_UPDATE = 'update';
export const ACTION_ITEM_STATUS_DISMISSED = 'dismissed';
export const ACTION_ITEM_STATUS_CANCELLED = 'cancelled';
export const ACTION_ITEM_STATUS_COMPLETED = 'completed';
export const ACTION_ITEM_STATUS_ERROR = 'error';
export const ACTION_ITEM_STATUS_PENDING = 'pending';

export const ACTION_ITEM_STATUSES = {
  ACTION_ITEM_STATUS_CANCELLED,
  ACTION_ITEM_STATUS_COMPLETED,
  ACTION_ITEM_STATUS_DISMISSED,
  ACTION_ITEM_STATUS_ERROR,
  ACTION_ITEM_STATUS_PENDING,
};

export const ACTION_ITEM_TYPES = {
  ACTION_ITEM_DELETE_ACCOUNT,
  ACTION_ITEM_INVITE,
  ACTION_ITEM_REMOVE_ACCOUNT_FROM_GROUP,
  ACTION_ITEM_UPDATE,
};

type ValueOf<T> = T[keyof T];

type ActionItemType = ValueOf<typeof ACTION_ITEM_TYPES>;

type ActionItemStatusType = ValueOf<typeof ACTION_ITEM_STATUSES>;

export interface BaseActionItem {
  _id?: string;
  account?: Pick<Account, '_id' | 'email' | 'full_name' | 'groups'>;
  action: ActionItemType;
  action_queue?: ActionQueue['_id'];
  error_causes: ErrorCause[];
  payload_raw?: Record<string, string>;
  skip?: boolean;
  status: ActionItemStatusType;
  updated_at?: Date;
}
export interface DeactivateActionItem extends BaseActionItem {
  payload_translated?: Pick<
    Account,
    '_id' | 'email' | 'first_name' | 'last_name'
  >;
}
export interface DeleteActionItem extends BaseActionItem {
  payload_translated?: Pick<
    Account,
    '_id' | 'email' | 'first_name' | 'last_name'
  >;
}
export interface InvitePayloadActionItem extends BaseActionItem {
  payload_translated?: PreregistrationAccount;
}
export interface UpdatePayloadActionItem extends BaseActionItem {
  payload_translated?: Pick<
    Account,
    | 'education'
    | 'email'
    | 'experience'
    | 'first_name'
    | 'full_name'
    | 'groups'
    | 'last_name'
    | 'locale_config'
    | 'status'
  >;
}

export type ExtendedPayloadActionItem =
  | InvitePayloadActionItem
  | UpdatePayloadActionItem;

export type ActionItem =
  | DeactivateActionItem
  | DeleteActionItem
  | InvitePayloadActionItem
  | UpdatePayloadActionItem;
